module.exports = {"name":"PersonalPage","buildDate":1699430875746,"version":"1.5.1","hash":"Not from git"}


/*****************
 ** WEBPACK FOOTER
 ** ./src/version.json
 ** module id = 688
 ** module chunks = 0
 **/